export function externalGuestDisplay(employee) {
  if (!employee?.is_external_guest) return null;
  const origin = employee.external_origin || {};
  const match = /^fw\d+abteilung(\d+)$/i.exec(origin.department_id || '');
  return {
    label: origin.station_id ? `Gast · ${origin.station_id}` : 'Gast anderer Wache',
    department: employee.external_department_name || (match ? `${match[1]}. Wachabteilung` : 'Herkunftsabteilung nicht verfügbar'),
  };
}
